/**
 * PostHog analytics event registry.
 *
 * Naming: app.screen.action.target
 * - app: dashboard | dashboard-spa …
 * - screen: kebab-case (e.g. keywords-search, user-profile)
 * - action: click | submit | open | close | input | …
 * - target (optional): kebab-case (e.g. search-button, primary-cta)
 *
 * Use these constants for data-ph-id in templates and for posthog.capture()
 * so event names stay in sync and are easy to refactor.
 */

export const AnalyticsEvents = {
  DASHBOARD: {
    KEYWORDS_ALL: {
      CLICK_EXPORT_ALL_KEYWORDS:
        "dashboard.keywords-all.click.export-all-keywords",
      CLICK_MANAGE_KEYWORDS:
        "dashboard.keywords-all.click.manage-keywords",
      CLICK_SEARCH:
        "dashboard.keywords-all.click.search",
      CLICK_MANAGE_NOTES:
        "dashboard.keywords-all.click.manage-notes",
    },
    CAMPAIGN_MANAGER: {
      VIEW_EXPAND_BACKLINK_DETAIL:
        "dashboard.campaign_manager.view.expand-backlink-detail",
    },
    TASKS: {
      CLICK_DESCRIPTION:
        "dashboard.tasks.click.description",
      CLICK_FILES:
        "dashboard.tasks.click.files",
      INPUT_KIND:
        "dashboard.tasks.input.kind",
      INPUT_ASSIGNED_TO:
        "dashboard.tasks.input.assigned-to",
      INPUT_PRIORITY:
        "dashboard.tasks.input.priority",
      INPUT_WATCHERS: // followed by
        "dashboard.tasks.input.watcher",
      INPUT_TASK_DUE_DATE:
        "dashboard.tasks.input.task-due-date",
      INPUT_TASK_REMINDER_DATE:
        "dashboard.tasks.input.task-reminder-date",
      INPUT_TASK_COMPLETION_DATE:
        "dashboard.tasks.input.task-completion-date",
      INPUT_KEYWORDS:
        "dashboard.tasks.input.keywords",
      INPUT_PAGES:
        "dashboard.tasks.input.pages",
      INPUT_STATUS:
        "dashboard.tasks.input.status",
      INPUT_ADD_TASK:
        "dashboard.tasks.click.add-task",
      CLICK_ARCHIVE_TASK:
        "dashboard.tasks.click.archive-task",
      CLICK_UNARCHIVE_TASK:
        "dashboard.tasks.click.unarchive-task",
      CLICK_DELETE_TASK:
        "dashboard.tasks.click.delete-task",
      CLICK_CREATE_TASK:
        "dashboard.tasks.click.create-task",
      CLICK_DUPLICATE_TASK:
        "dashboard.tasks.click.duplicate-task",
      UPDATE_TASK_STATUS:
        "dashboard.tasks.update.task-status"
    }
  },
};